import { mockCustomerDetails } from '@domgen/dgx-fe-common';
import { RegistrationRequest } from '../../models/registration/registration-request.interface';
import { mockRegistrationApplianceDetailsCLP } from '../registration-appliance-details/registration-appliance-details-clp.mock';

export const mockRegistrationRequestCLP: RegistrationRequest = {
  item: mockRegistrationApplianceDetailsCLP,
  person: mockCustomerDetails,
  quoteId: 'ebbdecec-5271-4e9f-aab8-fcdbadf9157e',
};
